import clsx from "clsx";
import type { HeroClass, HeroGender } from "../types";
import { getHeroAvatarObjectPosition, getHeroImagePath } from "../utils/assets";

interface HeroAvatarHeadProps {
  heroClass: HeroClass;
  gender: HeroGender;
  level: number;
  size?: "sm" | "md";
  className?: string;
  onClick?: () => void;
}

export function HeroAvatarHead({
  heroClass,
  gender,
  level,
  size = "md",
  className,
  onClick,
}: HeroAvatarHeadProps) {
  const dim = size === "sm" ? "w-9 h-9" : "w-11 h-11";
  const objectPosition = getHeroAvatarObjectPosition(heroClass);

  const content = (
    <>
      <div
        className={clsx(
          "hero-avatar-head overflow-hidden rounded-full border-2 border-amber-600/70 bg-kingdom-dark shadow-inner",
          dim,
        )}
      >
        <img
          src={getHeroImagePath(heroClass, gender)}
          alt=""
          className="hero-avatar-head__img w-full h-[175%] max-w-none object-cover pointer-events-none"
          style={{ objectPosition }}
        />
      </div>
      <span className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 min-w-[1.15rem] px-1 py-px rounded-full bg-kingdom-dark border border-amber-600/80 text-[9px] font-bold text-gold-300 text-center tabular-nums leading-none z-10 pointer-events-none">
        {level}
      </span>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={clsx(
          "relative shrink-0 rounded-full transition-transform active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-kingdom-glow/60",
          dim,
          className,
        )}
        aria-label="Open hero screen"
      >
        {content}
      </button>
    );
  }

  return <div className={clsx("relative shrink-0", dim, className)}>{content}</div>;
}
